import styled from 'styled-components';

export { StepContainer, StepIndicator, StepHeader, StepTitle, StepDescription } from '../step-shared/StepShared.styles.js';

export const ComingSoon = styled.span`
    font-weight: 600;
    opacity: 0.85;
`;
